import { render, staticRenderFns } from "./PhotoBookCoverListItem.vue?vue&type=template&id=9f8e9db2&scoped=true"
import script from "./PhotoBookCoverListItem.vue?vue&type=script&lang=js"
export * from "./PhotoBookCoverListItem.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookCoverListItem.vue?vue&type=style&index=0&id=9f8e9db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e9db2",
  null
  
)

export default component.exports